export default {
    WHITE: '#FFF',
    RED: '#FF0000',
    GREEN: '#11A99D',
    GREY: 'rgba(0, 0, 0, 0.298039)',
    BLACK: '#000'
};



// WEBPACK FOOTER //
// ./src/enums/ColorEnum.js